import { module } from "modujs";
import Swiper from "swiper";
import productGalleryMixin from "../vue-mixins/product-gallery-mixin";
import { html } from "../utils/environment";


// Install modules

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        // Retrieve shopify product values
        this.productTitle = this.getData("title");
        this.productVariants = JSON.parse(document.getElementById('productGalleryVariants').innerHTML);
        this.productCurrentVariantId = JSON.parse(
            this.getData("current-variant-id")
        );
        this.productImages = JSON.parse(this.getData("images"));

        // Init vue
        this.initVue();
    }

    initVue() {
        /////////////////////////
        // Save moduleInstance
        const moduleInstance = this;

        /////////////////////////
        // Settings
        Vue.config.devtools = true;

        /////////////////////////
        // Vue Instance
        this.app = new Vue({
            el: this.el,

            delimiters: ["${", "}"],

            mixins: [ productGalleryMixin ],

            data: {
                activeSwiperIndex: 0,
            },

            beforeCreate() {
                this.moduleInstance = moduleInstance;
            },

            mounted() {
                this.initSwiper()

                this.$nextTick(() => {
                    html.classList.add('is-gallery-ready')
                })
            },

            beforeDestroy() {
                this.unbindSwiperEvents()
                this.swiperInstance?.destroy()
                this.swiperThumbsInstance?.destroy()
            },

            methods: {
                initSwiper() {
                    if (!this.$refs.carousel && !this.$refs.carouselPagination) return

                    this.swiperInstance = new Swiper(this.$refs.carousel, {
                        slidesPerView: 1,
                    });

                    this.swiperThumbsInstance = new Swiper(this.$refs.carouselThumbs, {
                        slidesPerView: 3,
                        spaceBetween: 10,
                        direction: "vertical"
                    });

                    this.bindSwiperEvents()
                },

                onUpdateGallery() {
                    this.$nextTick(() => {
                        this.swiperInstance?.update()
                        this.swiperThumbsInstance?.update()

                        this.swiperInstance?.slideTo(0, 0)
                        this.swiperThumbsInstance?.slideTo(0, 0)
                    })
                },

                slideTo(index) {
                    this.swiperInstance?.slideTo(index)
                },

                bindSwiperEvents() {
                    this.onSlideChange = this.onSlideChange.bind(this)
                    this.swiperInstance?.on('slideChange', this.onSlideChange)
                },

                unbindSwiperEvents() {
                    this.swiperInstance?.off('slideChange', this.onSlideChange)
                },

                onSlideChange(swiper) {
                    this.activeSwiperIndex = swiper.activeIndex
                    this.swiperThumbsInstance?.slideTo(swiper.activeIndex)
                }
            }
        });
    }

    onProductVariantChange(variantId) {
        this.app?.onProductVariantChange?.(variantId)
    }

    destroy() {
        super.destroy();

        if (this.app) {
            this.app.$destroy();
        }
    }
}
